import { render, staticRenderFns } from "./selectionForm.vue?vue&type=template&id=222d3c70&scoped=true"
import script from "./selectionForm.vue?vue&type=script&lang=js"
export * from "./selectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d3c70",
  null
  
)

export default component.exports